import api from "./api";


 export const SupportTickets ={
 
    Createandupdate(payload){
        return api.post (`/report/create_update_ticket`,payload);

    },

    getAllTickets(payload){
        return api.put (`/report/get_tickets_by_client_factory`,payload);

    },

    
}
